import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as gtag from '../lib/gtag'
import { SHOW_POPUP } from '../store/slices/ui'
import { getPublicChatAvailable, panelSet } from '../store/slices/chatV2'
import HomepagePathChoiceV2 from './design-system/marketing/HomepagePathChoiceV2'
import { useOrderFlow } from './unified-order/OrderFlowProvider'
import ProductionPopup from './DeferredProductionPopup'
import QuotePop from './DeferredQuotePopup'

const HomepagePathChoice = ({ content }) => {
  const dispatch = useDispatch()
  const { launchIntent } = useOrderFlow()
  const publicChatAvailable = useSelector(getPublicChatAvailable)
  const paths = (content?.items || []).map(path => ({
    ...path,
    cta: {
      ...path.cta,
      onClick: () => {
        gtag.event({
          action: path.cta?.eventName,
          label: 'leads',
          value: 3,
          category: 'orders'
        })

        if (path.cta?.url === '#request-production-quote') {
          launchIntent({
            sourceSurface: 'homepage_managed_production',
            fulfillment: 'delivery_setup'
          }, () => dispatch(SHOW_POPUP({ key: 'quote', size: 'medium', body: <QuotePop /> })))
        } else if (path.cta?.url === '#event-builder') {
          launchIntent({
            sourceSurface: 'homepage_event_builder',
            fulfillment: 'delivery_setup'
          }, () => dispatch(SHOW_POPUP({ size: 'xl', key: 'prodpop', body: <ProductionPopup /> })))
        }
      }
    },
    links: (path.links || []).filter(link => (
      link.type !== 'chat' || publicChatAvailable
    )).map(link => ({
      ...link,
      onClick: () => {
        gtag.event({
          action: link.eventName,
          label: 'leads',
          value: link.type === 'phone' ? 15 : 3,
          category: 'orders'
        })

        if (link.type === 'chat') {
          dispatch(panelSet(true))
          window.dispatchEvent(new CustomEvent('msr:open-chat'))
        }
      }
    }))
  }))

  return <HomepagePathChoiceV2 content={content} paths={paths} />
}

export default HomepagePathChoice
